var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleSquares(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 497,
    height: 305,
    viewBox: "0 0 497 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 78.9664,
    width: 221.34,
    height: 221.34,
    transform: "rotate(-20.9017 0 78.9664)",
    fill: "#6C567B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 240.316,
    width: 145.965,
    height: 145.965,
    transform: "rotate(-64.1106 301 240.316)",
    fill: "#6C567B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleSquares);
export default __webpack_public_path__ + "static/media/middle-squares.b3edb6e5b8ba9a92b3d62e56159b88be.svg";
export { ForwardRef as ReactComponent };